// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

a {
  word-break: break-all;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1hbmFnZS1oZWxwLXNpdGUtbGlua3MuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0E7RUFDRSxjQUFBO0FBQUY7O0FBR0E7RUFDRSxxQkFBQTtBQUFGIiwiZmlsZSI6Im1hbmFnZS1oZWxwLXNpdGUtbGlua3MuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJcbjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG59XG5cbmEge1xuICB3b3JkLWJyZWFrOiBicmVhay1hbGw7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/components/casi-management/manage-help-site-links/manage-help-site-links.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;AACA,4ZAA4Z","sourcesContent":["\n:host {\n  display: block;\n}\n\na {\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
